import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { SeoElement } from '../SeoElement';
import { SeoImageLink } from '../SeoImageLink';

const SeoFragment = graphql(/* GraphQL */ `
  fragment SeoFragment on Product {
    name
    slug
    media {
      url
    }
    seoLinks: seo(locale: $locale) {
      ...SeoLinksFragment
    }
  }
`);

export const SeoList = ({ productData }: { productData: FragmentType<typeof SeoFragment> }) => {
  const product = getFragmentData(SeoFragment, productData);
  const { media, name, slug, seoLinks } = product;

  return (
    <>
      {media.length > 0 && media[0].url && (
        <SeoImageLink productName={name!} slug={slug!} imgSrc={media[0].url} />
      )}
      {seoLinks && <SeoElement seoLinksData={seoLinks} />}
    </>
  );
};
